import {IDeserializable} from '@app/core/models/deserializable.model';
import {InternationalizationService} from '@app/core/services/internationalization.service';
import {Store} from '@ngrx/store';
import {IAppState} from '@app/core/store/state/app.state';

export class BaseModel implements IDeserializable {
	public static readonly subjectType: string = '';
	public static readonly visibleCreated: string[] = [];
	public static readonly visibleUpdated: string[] = [];
	public static readonly dates: string[] = [];

	public tenantTZ: string;

	public static getTitle(tenantTZ: string, interService: InternationalizationService, activityDescription): string {
		return interService.translate.instant('ACTIVITY_LOG.' + activityDescription) + ' ' + interService.translate.instant('ACTIVITY_LOG.DEFINITE.' + this.subjectType);
	}

	public static formatAtt(tenantTZ: string, interService: InternationalizationService, store: Store<IAppState>, key, val): any {
		return val;
	}

	constructor(tenantTZ: string, public interService: InternationalizationService) {
		this.tenantTZ = tenantTZ;
	}

	public deserialize(input: any): this {
		return this;
	}

	public serialize(): any {
		return JSON.stringify(this, (key, value) => {
			if (key === 'interService') {
				return;
			}

			return value;
		});
	}
}
